import { getHttpClient } from '../axiosInstance'

const base = '/admin/settings/v1'

export const loadWorkingHours = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/working-hours`

  const response = await apiClient.get(url)
  return response.data
}

export const updateWorkingHours = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/working-hours`

  const response = await apiClient.post(url, form)
  return response.data
}

export const loadSmtp = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/smtp`

  const response = await apiClient.get(url)
  return response.data
}

export const updateSmtp = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/smtp`

  const response = await apiClient.post(url, form)
  return response.data
}

export const loadStorage = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/storage`

  const response = await apiClient.get(url)
  return response.data
}

export const updateStorage = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/storage`

  const response = await apiClient.post(url, form)
  return response.data
}

export const loadBrand = async () => {
  const apiClient = getHttpClient()
  // const url = `${base}/storage`
  const url = '/react/v1/configurations/companyInformation'

  const response = await apiClient.get(url)
  return response.data
}

export const updateBrand = async (form) => {
  const apiClient = getHttpClient()
  // const url = `${base}/storage`
  const url = '/react/v1/configurations/companyInformation'

  const response = await apiClient.post(url, form)
  return response.data
}

export const deleteStorageIntegration = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/storage/${id}`
  const response = await apiClient.delete(url, {})
  return response.data
}

export const enableStorageIntegration = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/storage/enable/${id}`
  const response = await apiClient.post(url, {})
  return response.data
}

export const disableStorageIntegration = async () => {
  const apiClient = getHttpClient()

  const url = `${base}/storage/disable`
  const response = await apiClient.post(url, {})
  return response.data
}
